var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags"},_vm._l((_vm.keywords),function(keyword,index){return _c('div',{staticClass:"chip",style:({background: _vm.bgcolor})},[_c('span',{on:{"click":function($event){_vm.changeTag(keyword)}}},[_c('md-icon',[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n      "+_vm._s(keyword)+"\n    ")],1)])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03e37773","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tags.vue
// module id = d0JZ
// module chunks = 1